// packages/private-apis/src/implementation.ts
var CORE_MODULES_USING_PRIVATE_APIS = [
  "@wordpress/admin-ui",
  "@wordpress/block-directory",
  "@wordpress/block-editor",
  "@wordpress/block-library",
  "@wordpress/blocks",
  "@wordpress/boot",
  "@wordpress/commands",
  "@wordpress/connectors",
  "@wordpress/workflows",
  "@wordpress/components",
  "@wordpress/content-types",
  "@wordpress/core-commands",
  "@wordpress/core-data",
  "@wordpress/customize-widgets",
  "@wordpress/data",
  "@wordpress/edit-post",
  "@wordpress/edit-site",
  "@wordpress/edit-widgets",
  "@wordpress/editor",
  "@wordpress/font-list-route",
  "@wordpress/format-library",
  "@wordpress/patterns",
  "@wordpress/preferences",
  "@wordpress/reusable-blocks",
  "@wordpress/rich-text",
  "@wordpress/route",
  "@wordpress/router",
  "@wordpress/routes",
  "@wordpress/sync",
  "@wordpress/theme",
  "@wordpress/dataviews",
  "@wordpress/fields",
  "@wordpress/lazy-editor",
  "@wordpress/media-editor",
  "@wordpress/media-utils",
  "@wordpress/upload-media",
  "@wordpress/global-styles-ui",
  "@wordpress/ui",
  "@wordpress/views"
];
var requiredConsent = "I acknowledge private features are not for use in themes or plugins and doing so will break in the next version of WordPress.";
var __dangerousOptInToUnstableAPIsOnlyForCoreModules = (consent, moduleName) => {
  if (!CORE_MODULES_USING_PRIVATE_APIS.includes(moduleName)) {
    throw new Error(
      `You tried to opt-in to unstable APIs as module "${moduleName}". This feature is only for JavaScript modules shipped with WordPress core. Please do not use it in plugins and themes as the unstable APIs will be removed without a warning. If you ignore this error and depend on unstable features, your product will inevitably break on one of the next WordPress releases.`
    );
  }
  if (consent !== requiredConsent) {
    throw new Error(
      `You tried to opt-in to unstable APIs without confirming you know the consequences. This feature is only for JavaScript modules shipped with WordPress core. Please do not use it in plugins and themes as the unstable APIs will removed without a warning. If you ignore this error and depend on unstable features, your product will inevitably break on the next WordPress release.`
    );
  }
  return {
    lock,
    unlock
  };
};
function lock(object, privateData) {
  if (!object) {
    throw new Error("Cannot lock an undefined object.");
  }
  const _object = object;
  if (!(__private in _object)) {
    _object[__private] = {};
  }
  lockedData.set(_object[__private], privateData);
}
function unlock(object) {
  if (!object) {
    throw new Error("Cannot unlock an undefined object.");
  }
  const _object = object;
  if (!(__private in _object)) {
    throw new Error(
      "Cannot unlock an object that was not locked before. "
    );
  }
  return lockedData.get(_object[__private]);
}
var lockedData = /* @__PURE__ */ new WeakMap();
var __private = /* @__PURE__ */ Symbol("Private API ID");
function allowCoreModule(name) {
  CORE_MODULES_USING_PRIVATE_APIS.push(name);
}
function resetAllowedCoreModules() {
  while (CORE_MODULES_USING_PRIVATE_APIS.length) {
    CORE_MODULES_USING_PRIVATE_APIS.pop();
  }
}
export {
  __dangerousOptInToUnstableAPIsOnlyForCoreModules,
  allowCoreModule,
  resetAllowedCoreModules
};
//# sourceMappingURL=implementation.mjs.map
